import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import get from 'lodash/get';
import { TYPE_COLORS_BY_KEY } from '../../common/constants';
import Result from './Result';

const styles = theme => ({
  root: {
    padding: 50,
    '& > div': {
      display: 'inline-block',
    },
  },
});

const ResultsProgress = ({ classes, ppr, onTargetAchieved: celebrate }) => {
  React.useEffect(() => {
    if (ppr) {
      const {
        actualWeeklyGp,
        targetWeeklyGp,
        actualHourLyCustomers,
        targetHourLyCustomers,
        actualWeeklyUpt,
        targetWeeklyUpt,
      } = ppr;
      if (
        celebrate &&
        targetWeeklyGp &&
        targetHourLyCustomers &&
        targetWeeklyUpt &&
        actualWeeklyGp >= targetWeeklyGp &&
        actualHourLyCustomers >= targetHourLyCustomers &&
        actualWeeklyUpt >= targetWeeklyUpt
      ) {
        celebrate();
      }
    }
  });

  return (
    <Card className={classes.root}>
      <div>
        <Result
          label={TYPE_COLORS_BY_KEY.gp.label}
          prefix="$"
          actual={get(ppr, 'actualWeeklyGp')}
          target={get(ppr, 'targetWeeklyGp')}
        />
      </div>
      <div>
        <Result
          label={TYPE_COLORS_BY_KEY.hc.label}
          actual={get(ppr, 'actualHourLyCustomers')}
          target={get(ppr, 'targetHourLyCustomers')}
        />
      </div>
      <div>
        <Result
          label={TYPE_COLORS_BY_KEY.upt.label}
          actual={get(ppr, 'actualWeeklyUpt')}
          target={get(ppr, 'targetWeeklyUpt')}
        />
      </div>
    </Card>
  );
};

export default withStyles(styles)(ResultsProgress);
